module.exports = __webpack_public_path__ + "img/scipy.86437b62.png";